module.exports = __webpack_public_path__ + "media/images/logo-desk-fr-2aa578c12e38d7515e82deff257e5038.svg";